import type { AxiosInstance, AxiosResponse } from 'axios';
import { govApiLog } from '@gov-nx/core/app';
import type { KosPolozkaKosSeznamDto, KosStrankovaniDto } from '../generated';
import type { EmptyRecycleBinParams } from '../types/queryTypes';

export const recycleBinQuery = async <T extends KosStrankovaniDto>({
	axiosInstance,
	...params
}: T & { axiosInstance: AxiosInstance }): Promise<KosPolozkaKosSeznamDto> => {
	govApiLog('/api/kompozitni/v1/polozkakos');
	const { data } = await axiosInstance.get('/api/kompozitni/v1/polozkakos', {
		params,
	});
	return data;
};

export const emptyRecycleBinQuery = async ({
	axiosInstance,
	...params
}: EmptyRecycleBinParams & {
	axiosInstance: AxiosInstance;
}): Promise<AxiosResponse> => {
	govApiLog('/api/kompozitni/v1/polozkakos');
	return axiosInstance.delete('/api/kompozitni/v1/polozkakos', { params });
};
